import React from "react";
import { Container, DiagnosisTable, Diagnosisdiv, Heading, Refresh, Table } from "../../style/Diagnosis";
import { GrRefresh } from "react-icons/gr";
import { IoIosAlert } from "react-icons/io";
import { CustomLink, ADImage } from "../../style/Dashboard";
import Modal from "../Modal/Modal";
import SimpleModal from "../Modal/DiagnosisModal";
import { CustomDiv } from "../../style/shared";
import { verifyAuth } from "../../authverify";
import moment from "moment";
import { ImCross } from "react-icons/im";
import Horizontal from "../../assets/Ads/Horizontal.jpeg";
import { CustomLinkButLink } from "../../style/Button";
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, styled } from "@mui/material";
import { Grid } from "@material-ui/core";
import "./Diagnosis.css";

export class Diagnosis extends React.Component {
  constructor(props) {
    super(props);

    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }

    this.logChildValue = this.logChildValue.bind(this);
    this.createRows = this.createRows.bind(this);
    this.restoreRows = this.restoreRows.bind(this);

    this.state = {
      rows: [],
      valuearr: [],
      imagebottom: "Ads/Horizontal4.jpeg",
    };
    this.restoreRows();
  }

  restoreRows() {
    let rowstring = window.sessionStorage.getItem("valuearr");
    if (rowstring) {
      this.state.valuearr = JSON.parse(rowstring);
    }
  }

  createRows = (value, index) => {
    this.state.rows.push();
  };

  removeRow = (index) => {
    const newRows = this.state.valuearr;
    newRows.splice(index, 1);
    this.setState({ valuearr: newRows });
    window.sessionStorage.setItem("valuearr", JSON.stringify(newRows));
  };

  logChildValue = (value) => {
    const formattedValue = JSON.parse(JSON.stringify(value));
    const newVal = this.state.valuearr;
    newVal.push(formattedValue);
    this.setState({ valuearr: newVal });
    window.sessionStorage.setItem(
      "valuearr",
      JSON.stringify(this.state.valuearr)
    );
    this.state.imagebottom = value.imageBottom;
  };

  render() {
    const { selectedBanner, setSelectedBanner, reactCreative, verticalCreative, popupCreative } = this.props;
    const ResponsiveTableContainer = styled(TableContainer)(({ theme }) => ({
      '@media (max-width: 600px)': {
        // For smaller screens, make the table scrollable horizontally
        overflowX: 'auto',
      },
    }));
    return (
      <Diagnosisdiv className={`${verticalCreative ? "" : "noCreative"}`}>
        <Grid container>
          <Grid item md={`${verticalCreative ? 8 : 12}`} lg={`${verticalCreative ? 9 : 12}`} xs={12}>
            <DiagnosisTable>
              <Container>
                <div className="diagnosis-mobile-header">
                  <Heading style={{ display: "flex", alignItems: "center", fontFamily: "work sans" }}>
                    Medical Problem{" "}
                    <SimpleModal
                      popupCreative={popupCreative}
                      onSubmitChild={this.logChildValue}
                      setSelectedBanner={setSelectedBanner}
                    />
                  </Heading>
                  <Refresh to="#" onClick={(e) => e.preventDefault()}>
                    <GrRefresh color="#4678ED" style={{ color: "#4678ED",marginBottom: "2px", marginRight: "3px" }} /> Reset
                    Portal Credentials
                  </Refresh>
                </div>
                <ResponsiveTableContainer component={Paper} className="diagnosis-table-wrap" elevation={0}>
                  <Table aria-label="simple table" className="diagnosis-table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Title</TableCell>
                        <TableCell>Coding</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Occurrence</TableCell>
                        <TableCell style={{ textAlign: "center" }}>Verification Status</TableCell>
                        <TableCell>Referred By</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell style={{ textAlign: "center" }}>Edit</TableCell>
                        <TableCell>Remove</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.valuearr.map((value, index) => (

                        <TableRow key={index}>
                          <TableCell>{value.title}</TableCell>
                          <TableCell>{value.coding}</TableCell>
                          <TableCell>{value.status}</TableCell>
                          <TableCell>Unknown or N/A</TableCell>
                          <TableCell style={{ textAlign: "center", fontSize: "18px" }}>
                            <IoIosAlert color="red" />
                          </TableCell>
                          <TableCell>Tom Collins</TableCell>
                          <TableCell>{value.beginDate}</TableCell>
                          <TableCell style={{ textAlign: "center", color: "#488AED" }}>
                            <Modal />
                          </TableCell>
                          <TableCell>
                            <ImCross
                              onClick={() => this.removeRow(index)}
                              style={{ fill: "#969696", marginLeft: "15px" }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </ResponsiveTableContainer>
              </Container>
              <div className="text-right" style={{ marginTop: "20px" }}>
                <CustomLinkButLink to="/People/Procedures">
                  Back
                </CustomLinkButLink>
                <CustomLinkButLink primary to="/People/Prescription">
                  Next
                </CustomLinkButLink>
              </div>
              {
                reactCreative &&
                <div className=" mobileCss mobCenter" style={{ width: "300px" }}>
                  <div className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px', }}>
                    <iframe
                      title="iframe"
                      srcDoc={reactCreative}
                      style={{
                        width: '100%',
                        height: '100%',
                        maxWidth: '100%',
                        minHeight: '250px',
                        marginBottom: "30px"
                      }}
                      frameBorder="0"
                      scrolling="no"
                    />
                  </div>
                </div>
              }

            </DiagnosisTable>
          </Grid>
          {
            verticalCreative &&
            <Grid item md={4} lg={3} xs={12}>
              <div className="text-right  mobileCss mobCenter  d-flex justify-content-end">
                <div className='responsiveMargin'  style={{ maxWidth: '300px', minHeight: '600px',}}>
                  <iframe
                    title="iframe"
                    srcDoc={verticalCreative}
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '100%',
                      minHeight: '600px',
                      marginBottom: "30px"
                    }}
                    frameBorder="0"
                    scrolling="no"
                  />
                </div>
              </div>
            </Grid>
          }
        </Grid>
      </Diagnosisdiv >
    );
  }
}
